export const messageValidator = {
    email_required: "* Email is required",
    email_invalid: "* Email is not in the correct format",
    password_required: "* Password is required",
    password_min: "* Password must have at least 6 characters",
    user_name_required: "* Username is required",
    user_name_size: "* User name from 3-15 characters"
}